// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"fO-z","carouselContainer":"gO-z"};